export const TRAINING_REMARKS_FIELD_NAME = "remarks";
